/**
 * 🧱 Refactor BT Phase 3 — Étape 2 : section « SectionHeureDebutPluie » d'EditerBonTravailDialog.jsx.
 * JSX déplacé TEL QUEL (ex-L1551-1655, dédenté de 10) ; variables lues via `useBTForm()`
 * (BTFormProvider enrichi par `extra` dans le composant parent). DOM, data-testid, classes, textes inchangés.
 */
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { Clock } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useBTForm } from '../../BTFormContext';

export function SectionHeureDebutPluie() {
  const {
    form,
    isExt,
    setForm,
    type,
  } = useBTForm();
  return (
    <>
      {/* Heure de début + Jours de pluie */}
      <div className="grid grid-cols-2 gap-4">
        <Card>
          <CardHeader><CardTitle className="text-base flex items-center gap-1"><Clock className="w-4 h-4" /> Heure de début</CardTitle></CardHeader>
          <CardContent>
            <Input
              type="time"
              value={form.heure_debut}
              onChange={(e) => setForm(f => ({ ...f, heure_debut: e.target.value }))}
              data-testid="edit-bon-heure-debut"
            />
            <p className="text-xs text-gray-400 mt-1">Alerte SMS si non pointé après 31 min</p>
          </CardContent>
        </Card>
        {/* 🔄 B4 — Dates fixes (Eliot, 2026-05-04) */}
        <Card>
          <CardHeader><CardTitle className="text-base flex items-center gap-2"><span>⛔</span> Dates fixes</CardTitle></CardHeader>
          <CardContent className="pt-2">
            <div className="flex items-center gap-3">
              <Checkbox
                id="edit_dates_fixes"
                checked={!!form.dates_fixes}
                onCheckedChange={(v) => setForm(f => ({ ...f, dates_fixes: !!v }))}
                data-testid="edit-bon-dates-fixes"
              />
              <label htmlFor="edit_dates_fixes" className="text-sm cursor-pointer">
                Ce BT est en dates fixes — ne pas reporter
              </label>
            </div>
            <p className="text-xs text-gray-400 mt-1">
              Affiché avec ⛔ dans le Calendrier de Production pour repérage rapide.
            </p>
          </CardContent>
        </Card>
        {/* 🆕 2026-05-06 Module CCQ — Régime applicable */}
        <Card className={form.regime_ccq === 'ccq' ? 'border-violet-300 bg-violet-50/30' : ''}>
          <CardHeader>
            <CardTitle className="text-base flex items-center gap-2">
              <span>🏛️</span> Régime salarial CCQ
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-2">
            <div className="grid grid-cols-2 gap-2">
              <button
                type="button"
                onClick={() => setForm(f => ({ ...f, regime_ccq: 'hors_ccq' }))}
                className={`p-3 rounded-lg border-2 text-sm font-medium transition ${
                  form.regime_ccq !== 'ccq'
                    ? 'border-slate-400 bg-slate-100 text-slate-800'
                    : 'border-slate-200 bg-white text-slate-500 hover:bg-slate-50'
                }`}
                data-testid="bt-regime-hors-ccq"
              >
                🏠 Hors CCQ (résidentiel)
              </button>
              <button
                type="button"
                onClick={() => setForm(f => ({ ...f, regime_ccq: 'ccq' }))}
                className={`p-3 rounded-lg border-2 text-sm font-medium transition ${
                  form.regime_ccq === 'ccq'
                    ? 'border-violet-500 bg-violet-100 text-violet-800'
                    : 'border-slate-200 bg-white text-slate-500 hover:bg-slate-50'
                }`}
                data-testid="bt-regime-ccq"
              >
                🏛️ CCQ (commercial / industriel)
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-2">
              {form.regime_ccq === 'ccq'
                ? '✅ Les heures sur ce BT seront calculées selon la grille CCQ active + le grade de chaque employé.'
                : 'Les heures utiliseront le salaire hors-CCQ standard de chaque employé.'}
            </p>
          </CardContent>
        </Card>
        {!isExt && (
          <Card>
            <CardHeader><CardTitle className="text-base">Temps de pluie</CardTitle></CardHeader>
            <CardContent className="flex flex-col gap-2 pt-2">
              <div className="flex items-center gap-3">
                <Checkbox
                  id="edit_jours_pluie"
                  checked={form.jours_pluie}
                  onCheckedChange={(v) => setForm(f => ({ ...f, jours_pluie: !!v }))}
                  data-testid="edit-bon-jours-pluie"
                />
                <label htmlFor="edit_jours_pluie" className="text-sm cursor-pointer">Réalisable par temps de pluie</label>
              </div>
              {form.jours_pluie && (
                <div className="grid grid-cols-2 gap-2 mt-1">
                  <div>
                    <Label className="text-xs">Du</Label>
                    <Input type="date" value={form.pluie_date_debut} onChange={(e) => setForm(f => ({ ...f, pluie_date_debut: e.target.value }))} className="h-8 text-sm" data-testid="pluie-date-debut" />
                  </div>
                  <div>
                    <Label className="text-xs">Au</Label>
                    <Input type="date" value={form.pluie_date_fin} onChange={(e) => setForm(f => ({ ...f, pluie_date_fin: e.target.value }))} className="h-8 text-sm" data-testid="pluie-date-fin" />
                  </div>
                </div>
              )}
            </CardContent>
          </Card>
        )}
      </div>

    </>
  );
}
